import { FlightWayEnum, cabinOptionMap, flightWayOptions, passengerTypeOptions } from "@/constants";
import { SearchConditionType } from "@/hooks/useSearchCondition";

export function createSearchQuery(condition: SearchConditionType) {
  let date = {};

  if (condition.flightWay === FlightWayEnum.OneWay) {
    if (condition.range) {
      date = {
        oneWayRangeStartDate: condition.oneWayRangeStartDate / 1000,
        oneWayRangeEndDate: condition.oneWayRangeEndDate / 1000,
      };
    } else {
      date = {
        oneWayDate: condition.oneWayDate / 1000,
      };
    }
  } else if (condition.flightWay === FlightWayEnum.RoundTrip) {
    if (condition.range) {
      date = {
        departureRangeStartDate: condition.departureRangeStartDate / 1000,
        departureRangeEndDate: condition.departureRangeEndDate / 1000,
        returnRangeStartDate: condition.returnRangeStartDate / 1000,
        returnRangeEndDate: condition.returnRangeEndDate / 1000,
      };
    } else {
      date = {
        roundTripDepartureDate: condition.roundTripDepartureDate / 1000,
        roundTripReturnDate: condition.roundTripReturnDate / 1000,
      };
    }
  }

  return {
    flightWay: condition.flightWay,
    pax: String(condition.pax),
    children: String(condition.children),
    cabins: condition.cabins,
    range: String(condition.range),
    rangeV2: condition.rangeV2 ? String(true) : String(false),
    from: condition.fromLocation.map((ele) => ele.iata).join("-"),
    to: condition.toLocation.map((ele) => ele.iata).join("-"),
    programs: condition.programs?.join("-") || "",
    targetId: condition.targetId || "",
    ...date,
  };
}

export function parseSearchQuery(searchParams: URLSearchParams) {
  const params = {} as any;

  for (const [key, value] of searchParams.entries()) {
    params[key] = value;
  }

  const date = {
    oneWayDate: params.oneWayDate ? Number(params.oneWayDate) * 1000 : 0,
    oneWayRangeStartDate: params.oneWayRangeStartDate
      ? Number(params.oneWayRangeStartDate) * 1000
      : 0,
    oneWayRangeEndDate: params.oneWayRangeEndDate ? Number(params.oneWayRangeEndDate) * 1000 : 0,

    roundTripDepartureDate: params.roundTripDepartureDate
      ? Number(params.roundTripDepartureDate) * 1000
      : 0,
    roundTripReturnDate: params.roundTripReturnDate ? Number(params.roundTripReturnDate) * 1000 : 0,

    departureRangeStartDate: params.departureRangeStartDate
      ? Number(params.departureRangeStartDate) * 1000
      : 0,
    departureRangeEndDate: params.departureRangeEndDate
      ? Number(params.departureRangeEndDate) * 1000
      : 0,
    returnRangeStartDate: params.returnRangeStartDate
      ? Number(params.returnRangeStartDate) * 1000
      : 0,
    returnRangeEndDate: params.returnRangeEndDate ? Number(params.returnRangeEndDate) * 1000 : 0,
  };

  return {
    flightWay: params.flightWay || flightWayOptions[0].value,
    pax: Number(params.pax) || passengerTypeOptions[0].value,
    children: Number(params.children) || 0,
    cabins: params.cabins
      ? decodeURIComponent(params.cabins)?.replaceAll?.("+", " ")
      : cabinOptionMap[0].value,

    range: params.range === "true" ? true : false,
    rangeV2: params.rangeV2 === "true" ? true : false,
    programs: params.programs ? params.programs.split("-") : [],
    targetId: params.targetId || "",
    fromLocation: params.from
      ? params.from.split("-").map((ele: string) => {
          return {
            iata: ele,
          };
        })
      : [],
    toLocation: params.to
      ? params.to.split("-").map((ele: string) => {
          return {
            iata: ele,
          };
        })
      : [],

    ...date,
  };
}
